<template>
  <v-card
    :width="newWidth"
    :elevation="elevation"
    class="ma-3"
    :style="newStyle"
    :flat="flat"
  >
    <slot v-if="title">
      <div class="d-flex flex-column" v-if="title">
        <div
          class="d-flex justify-space-between align-center"
          style="width:95%;"
        >
          <h2 class="py-3 pl-4">
            {{ title }}
          </h2>
          <div
            style="background-color:orange; color:white; height:30px; border-radius:5px; width:70px"
            v-if="uptime"
            class="d-flex justify-center align-center"
          >
            <h4 class="py-3">{{ uptime }}</h4>
          </div>
        </div>
        <h3 class="py-3 pl-4" v-if="secondaryTitle">
          {{ secondaryTitle }}
        </h3>
      </div>
    </slot>
    <component
      ref="subchart"
      v-on="$listeners"
      v-if="data && !loading"
      :is="type"
      :data="data"
      :labels="labels"
      :customOptions="options"
      :yAxis="yAxis"
      :total="total"
      :logo="logo"
      :raw="raw"
      :title="title"
      :height="height"
      :horizontal="horizontal"
    />
    <div class="d-flex justify-center" v-if="overdue > -1 && !loading">
      <div
        style="background-color:red; color:white; font-weight:bold;"
        class="px-3 py-1"
      >
        Overdue {{ overdue }}
      </div>
    </div>
    <div
      class="d-flex justify-center align-center"
      style="min-height:150px;"
      v-if="loading"
    >
      <v-progress-circular indeterminate size="64" />
    </div>
  </v-card>
</template>

<script>
import { card, MobileView } from '@/mixins';
import Pie from '@/components/charts/Pie';
import Donut from '@/components/charts/Donut';
import RadialBar from '@/components/charts/RadialBar';
import LineChart from '@/components/charts/LineChart';
import Gauge from '@/components/charts/Gauge';
import BarChart from '@/components/charts/BarChart';
import router from '../../router';

export default {
  name: 'chart',
  components: {
    Pie,
    Donut,
    RadialBar,
    LineChart,
    Gauge,
    BarChart,
  },
  props: [
    'type',
    'data',
    'labels',
    'title',
    'secondaryTitle',
    'elevation',
    'options',
    'width',
    'uptime',
    'total',
    'yAxis',
    'overdue',
    'height',
    'flat',
    'logo',
    'raw',
    'horizontal',
    'loading',
  ],
  mixins: [card, MobileView],
  computed: {
    newWidth() {
      if (this.width) {
        return this.width;
      }
      if (
        !this.showMobileView
          && router.history.current.name === 'Reconciliation'
      ) {
        return '65vw';
      } if (
        !this.showMobileView
          && router.history.current.name === 'Reports'
      ) {
        return this.cardWidth;
      }
      return this.cardWidth;
    },
    newStyle() {
      if (this.height) {
        return `max-height: ${this.height};`;
      }
      return 'min-height: 100%';
    },
  },
};
</script>
